import { render, staticRenderFns } from "./MotivationAvatarLG.vue?vue&type=template&id=7f13c655&scoped=true&"
import script from "./MotivationAvatarLG.vue?vue&type=script&lang=js&"
export * from "./MotivationAvatarLG.vue?vue&type=script&lang=js&"
import style0 from "./MotivationAvatarLG.vue?vue&type=style&index=0&id=7f13c655&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f13c655",
  null
  
)

export default component.exports